import { observer } from "mobx-react";
import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { CountdownTimer } from "components/CountdownTimer/CountdownTimer";
import { TEST_ENVIRONMENT_ROUTES } from "constants/routes";
import { useScheduledTests } from "hooks/useScheduledTests";

import { TestHeader } from "pages/TestEnvironment/components/TestHeader/TestHeader";
import type { TestPagePathParams } from "../../subpages/TestOverviewPage/TestOverviewPage.model";
import type { ScheduledTestHeaderProps } from "./ScheduledTestHeader.model";

export const ScheduledTestHeader: React.FC<ScheduledTestHeaderProps> = observer(
  ({ counter, title, onClose }) => {
    const { t } = useTranslation("test-environment");
    const { scheduledTestStatusAndTimeLeft } = useScheduledTests();
    const navigate = useNavigate();
    const { code } = useParams() as unknown as TestPagePathParams;

    return (
      <TestHeader
        rightComponent={
          scheduledTestStatusAndTimeLeft?.counter !== undefined && (
            <CountdownTimer
              prefix={t("navbar.timeLeft", "Time left: ")}
              secondsLeft={counter}
              warningTimeSeconds={10 * 60}
              onCountdownFinish={() =>
                navigate(
                  buildUrlWithPathParams(TEST_ENVIRONMENT_ROUTES.TEST_COMPLETED_PAGE, { code }),
                  {
                    replace: true,
                  },
                )
              }
            />
          )
        }
        title={title}
        onClose={onClose}
      />
    );
  },
);
